// 
import WebComponent from '../webComponents/WebComponent';

/**
 * automatické ošetření sdílecích tlačítek.
 *
 * HTML markup
 *  <a id="SocialShare" href="" data-is="SocialShare" data-social-network="twitter"> Sdílet na Twitteru</a>
 *
 * data-social-network: facebook | twitter | linkedin | pinterest
 *
 * na odkaz možno dodat data:
 * data-title-share - vlastní titulek (pokud má být různý od document.title)
 * data-url-share - vlastní URL sdíleného článku, pokud se má lišit od document.URL
 * data-pinterest-image - podstrčení obrázku, který má být připinnován na pinterest
 */
class SocialShare extends WebComponent {
  constructor(props) {
    super(props);
    this.type = null;
    this.pageUrl = null;
    this.pageName = null;
    this.imageUrl = null;
    this.getProperties = this.getProperties.bind(this);
    this.buildShareStrings = this.buildShareStrings.bind(this);
  }

  didMount() {
    this.getProperties();
    this.buildShareStrings();
  }

  willUnMount() {
    this.type = null;
    this.pageUrl = null;
    this.pageName = null;
    this.imageUrl = null;
  }

  getProperties() {
    const {
      socialNetwork,
      urlShare,
      titleShare,
      pinterestImage,
    } = this.props;

    const imageMeta = document.querySelectorAll('meta[property="og:image"]')[0];
    let imageMetadata = '';
    if (typeof imageMeta !== 'undefined') {
      imageMetadata = imageMeta.content;
    }

    this.type = socialNetwork;
    this.pageUrl = urlShare || String(document.URL);
    this.pageName = titleShare || document.title;
    this.imageUrl = pinterestImage || imageMetadata;

    this.pageName = this.pageName.replace('--', '');
  };

  buildShareStrings() {
    const {
      services,
    } = this.props;

    let url = '';
    let title = '';
    let image = '';
    let str = '';

    switch (this.type) {
      case 'facebook' :
        url = encodeURIComponent(this.pageUrl);
        title = encodeURIComponent(this.pageName);
        break;
      case 'twitter':
        str = '';
        str += (this.pageName !== '') ? this.pageName+': ' : '';
        str += this.pageUrl;
        title = encodeURIComponent(str);
        break;
      case 'linkedin':
        url = encodeURIComponent(this.pageUrl);
        title = encodeURIComponent(this.pageName);
        break;
      case 'pinterest':
        url = encodeURIComponent(this.pageUrl);
        title = encodeURIComponent(this.pageName);

        if ((this.imageUrl).indexOf('//') != -1) {
          image = encodeURIComponent(this.imageUrl);
        }
        else {
          image = encodeURIComponent(window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '') + this.imageUrl); // window.location.origin not used due to IE
        }
        break;
      default:
        break;
    }

    this.element.href = services[this.type].replace(/\${url}/gi,url).replace(/\${title}/gi,title).replace(/\${image}/gi,image);
    this.element.setAttribute('target','_blank');
  };

}

SocialShare.defaultProps = {
  services: {
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=${url}&t=${title}',
    twitter:  'https://twitter.com/intent/tweet?text=${title}',
    linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=${url}&title=${title}',
    pinterest: 'https://pinterest.com/pin/create/button/?url=${url}&media=${image}&description=${title}'
  },
}

export default SocialShare;



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/SocialShare.js